import styled from 'styled-components';
import { layout } from '@prisjakt/ui-base';
import ButtonComponent from '@prisjakt/ui-button';
import { CaptionText } from '@prisjakt/ui/text/variants';

export const Wrapper = styled.div`
  display: grid;
  grid-template-rows: repeat(auto-fill, minmax(75px, 1fr));
  gap: 0.5rem;
`;

export const ExpandButton = styled(ButtonComponent)`
  padding: 0;
  padding-top: ${layout.measurements.spacingNormal};
  width: 100%;

  span {
    justify-content: flex-start;
  }
`;

export const Position = styled(CaptionText)`
  color: ${p => p.theme.text.callToAction};
`;

export const ExpertCount = styled(CaptionText)`
  color: ${p => p.theme.text.secondary};
`;

export const Image = styled.img`
  height: 100%;
  object-fit: cover;
`;
